import * as React from "react";
import {useCustomerContext} from "../../../customer/CustomerContextProvider/CustomerContextProvider";
import ListLoader from "../../../utils/loader/ListLoader";
import {IIsVisible} from "../../Checkout";
import KnownCustomer from "./KnownCustomer";
import "./Login.scss";
import NewCustomer from "./NewCustomer";

const Login: React.FC<IIsVisible> = (props) => {
  const {customer} = useCustomerContext();

  if (!props.isVisible) {
    return null;
  }

  return (
    <div className={"Login text"}>
      <React.Suspense fallback={<ListLoader />}>
        <KnownCustomer />
        {!customer.isRecognised && <NewCustomer />}
      </React.Suspense>
    </div>
  );
};

export default Login;
